import React from "react";

const CreateUserType: React.FC = () => {
  return <div>CreateUserType</div>;
};

export default CreateUserType;
